import * as Yup from 'yup';

import { yupPasswordSchema } from '/b2b/common/helpers/Password';

export const resetPasswordSchema = Yup.object().shape({
    newPassword: yupPasswordSchema.clone().required(),
    confirmNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'password.validations.notMatching')
        .required(),
});
